import { DEFAULT_BRAND } from '@thesavingsgroup/constants';
import { get } from 'lodash';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleBrand = (vehicle: DashboardVehicle): string =>
  get(vehicle, 'application.brand', DEFAULT_BRAND);
